/**
 * @file 慧播星打点
 * @description ubc sdk用法 https://console.cloud.baidu-int.com/devops/icode/repos/baidu/jady/ubc-report-sdk/blob/master/README.md
 * @author
 */

import {ubcLogger, UbcLogger} from '@baidu/ubc-report-sdk';
import parseUrl from '../../../utils/parseUrl';
import {formatDate} from '../../../utils/dateFormat';
import {getVideoMetaInfo} from '../services';
import {store} from '../stores';

export * from './smartScriptLog';
export * from './aiScriptTool';
export * from './ernieLog';
export * from './characterCreate';
export * from './aigcScript';
const faqId = 17181; // 问答相关
const reserveAIId = 17182; // AI生成预约直播间内容相关
const backgroundId = 17185; // 背景素材相关
const aiTTSTextId = 17186; // AI辅写相关
const aiTTSAsrId = 17425; // 音频asr相关
const aigcImgId = 17202; // AIGC生成图片
const homeSourceId = 17262; // 首页不同来源的访问量
const efficiencyId = 17275; // 操作效率埋点
const aigcVideoDownloadId = 17276; // AIGC生成视频-下载按钮
const aigcVideoCreateId = 17277; // AIGC生成视频-生成按钮
const aigcVideoLaunchId = 17358; // AIGC生成视频-投放按钮
const goodsScenesId = 17297; // 商品分镜操作
const reserveErnieFaqId = 17293; // 预约窗口 文心接管问答授权按钮
const headerActionBarId = 17325; // 顶部操作栏素材按钮
const headerRightBarId = 17324; // 顶部右侧操作栏按钮
const adjustId = 17323; // 布局调整按钮
const templateCarateId = 17468; // 模板生成相关埋点
const editorMenuFloatId = 17599; // 编辑器悬浮菜单
const editorHotKeyId = 17600; // 编辑器快捷键
const editorMenuRightId = 17601; // 编辑器右键菜单
const aigcQuestionsAnswersId = 17462; // 一言问答统计相关
const productQALibraryId = 17500; // 商品问答库数据埋点
const sayasId = 17517;// 文案修改读音
const layerManagerId = 17593; // 图层管理器
const entryGuidePageId = 17575; // 入驻引导页
const scripListId = 17574; // 剧本页
const infoBannerId = 17572; // 通知与banner
const riskDiagnosisId = 17573; // 风险诊断
const learnCenterId = 17584; // 学习中心
const createCharacterId = 17602; // 创建人像
const createPptId = 17665; // 创建ppt
const pptSwitchId = 17666; // 播报文案ppt开关
const pptClipId = 17670; // ppt裁剪
const pptOperateId = 18361; // ppt操作
const pasterUsedId = 18440; // 数字人商品展示素材使用
const rookieGuideId = 18444; // 新手引导
const swanCloneId = 18578; // 收声小程序B端入口

const faqLogger = new UbcLogger({
    from: 'qa',
    page: 'huibo',
    ev_l_t: 'click',
    serverId: faqId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});

const reserveAILogger = new UbcLogger({
    from: 'script',
    page: 'huibo',
    ev_l_t: 'click',
    serverId: reserveAIId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});

const backgroundLogger = new UbcLogger({
    from: 'script',
    page: 'huibo',
    ev_l_t: 'click',
    serverId: backgroundId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});

const aiTTSTextLogger = new UbcLogger({
    from: 'script',
    page: 'huibo',
    ev_l_t: 'click',
    serverId: aiTTSTextId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});

const aiTTSAsrLogger = new UbcLogger({
    from: 'script',
    page: 'huibo',
    ev_l_t: 'click',
    serverId: aiTTSAsrId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});


const aigcImgLogger = new UbcLogger({
    from: 'huibo',
    page: 'aiimg',
    ev_l_t: 'click',
    serverId: aigcImgId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});

const homeSourceLogger = new UbcLogger({
    from: 'huibo',
    page: 'home',
    ev_l_t: 'show',
    serverId: homeSourceId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});

const mobileRegisterClkLogger = new UbcLogger({
    from: 'huibo',
    page: 'mobile',
    ev_l_t: 'show',
    serverId: homeSourceId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});

const efficiencyLogger = new UbcLogger({
    from: 'huibo',
    page: 'all',
    ev_l_t: 'click',
    serverId: efficiencyId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});

const aigcVideoDownloadLogger = new UbcLogger({
    from: 'huibo',
    page: 'script',
    ev_l_t: 'click',
    serverId: aigcVideoDownloadId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});

const aigcVideoCreateLogger = new UbcLogger({
    from: 'huibo',
    page: 'script',
    ev_l_t: 'click',
    serverId: aigcVideoCreateId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});

const aigcVideoLaunchLogger = new UbcLogger({
    from: 'huibo',
    page: 'script',
    ev_l_t: 'click',
    serverId: aigcVideoLaunchId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});

const goodsScenesLogger = new UbcLogger({
    from: 'huibo',
    page: 'eidtor',
    ev_l_t: 'click',
    serverId: goodsScenesId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});

const reserveErnieFaqLogger = new UbcLogger({
    from: 'huibo',
    page: 'reserve',
    ev_l_t: 'click',
    serverId: reserveErnieFaqId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});

const headerAcitonBarLogger = new UbcLogger({
    from: 'huibo',
    page: 'header',
    ev_l_t: 'click',
    serverId: headerActionBarId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});

const headerRightBarLogger = new UbcLogger({
    from: 'huibo',
    page: 'header',
    ev_l_t: 'click',
    serverId: headerRightBarId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});

const adjustLogger = new UbcLogger({
    from: 'huibo',
    page: 'header',
    ev_l_t: 'click',
    serverId: adjustId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});


const templateCreateLogger = new UbcLogger({
    from: 'huibo',
    page: 'script',
    ev_l_t: 'click',
    serverId: templateCarateId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});

const editorMenuFloatLogger = new UbcLogger({
    from: 'huibo',
    page: 'eidtor',
    ev_l_t: 'click',
    serverId: editorMenuFloatId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});

const editorMenuRightLogger = new UbcLogger({
    from: 'huibo',
    page: 'eidtor',
    ev_l_t: 'click',
    serverId: editorMenuRightId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});

const editorHotKeyLogger = new UbcLogger({
    from: 'huibo',
    page: 'eidtor',
    ev_l_t: 'click',
    serverId: editorHotKeyId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});

const aigcQuestionsAnswersLogger = new UbcLogger({
    from: 'huibo',
    page: 'home',
    ev_l_t: 'click',
    serverId: aigcQuestionsAnswersId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});

const productTabLibraryLogger = new UbcLogger({
    from: 'huibo',
    page: 'tab',
    ev_l_t: 'click',
    serverId: productQALibraryId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});

const productEditLibraryLogger = new UbcLogger({
    from: 'huibo',
    page: 'script_edit',
    ev_l_t: 'click',
    serverId: productQALibraryId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});

const productQALibraryLogger = new UbcLogger({
    from: 'huibo',
    page: 'Q_A',
    ev_l_t: 'click',
    serverId: productQALibraryId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});

const sayasLogger = new UbcLogger({
    from: 'huibo',
    page: 'home',
    ev_l_t: 'click',
    serverId: sayasId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});

const entryGuidePageLogger = new UbcLogger({
    from: 'huibo',
    ev_l_t: 'click',
    serverId: entryGuidePageId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});

const scripListLogger = new UbcLogger({
    from: 'huibo',
    ev_l_t: 'click',
    serverId: scripListId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});

const infoBannerLogger = new UbcLogger({
    from: 'huibo',
    ev_l_t: 'click',
    serverId: infoBannerId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});

const riskDiagnosisLogger = new UbcLogger({
    from: 'huibo',
    ev_l_t: 'click',
    serverId: riskDiagnosisId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});

const learnCenterLogger = new UbcLogger({
    from: 'huibo',
    ev_l_t: 'click',
    serverId: learnCenterId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});
const createCharacterLogger = new UbcLogger({
    from: 'huibo',
    ev_l_t: 'click',
    page: 'character',
    serverId: createCharacterId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});

const layerManagerLogger = new UbcLogger({
    from: 'huibo',
    page: 'script_edit',
    ev_l_t: 'click',
    serverId: layerManagerId
});

const createPptLogger = new UbcLogger({
    from: 'huibo',
    ev_l_t: 'click',
    page: 'editor',
    serverId: createPptId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});

const pptOperateLogger = new UbcLogger({
    from: 'huibo',
    ev_l_t: 'click',
    page: 'editor',
    serverId: pptOperateId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});

const pptSwitchLogger = new UbcLogger({
    from: 'huibo',
    ev_l_t: 'click',
    page: 'editor',
    serverId: pptSwitchId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});

const pptClipLogger = new UbcLogger({
    from: 'huibo',
    ev_l_t: 'click',
    page: 'editor',
    serverId: pptClipId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});

const pasterUsedLogger = new UbcLogger({
    from: 'huibo',
    ev_l_t: 'click',
    page: 'editor',
    serverId: pasterUsedId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});

const rookieGuideLogger = new UbcLogger({
    from: 'huibo',
    ev_l_t: 'click',
    page: 'editor',
    serverId: rookieGuideId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});

const swanCloneLogger = new UbcLogger({
    from: 'huibo',
    ev_l_t: 'click',
    page: 'editor',
    serverId: swanCloneId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});

const logMap = {
    faq: {
        logger: faqLogger,
        commonParams: {
            from: 'qa',
            ev_l_t: 'click',
            pos_id: '1662_1663_'
        }
    },
    reserveAI: {
        logger: reserveAILogger,
        commonParams: {
            from: 'script',
            ev_l_t: 'click',
            pos_id: '1662_1665_'
        }
    },
    bg: {
        logger: backgroundLogger,
        commonParams: {
            from: 'script',
            ev_l_t: 'click',
            pos_id: '1662_1666_'
        }
    },
    aiTTSText: {
        logger: aiTTSTextLogger,
        commonParams: {
            from: 'script',
            ev_l_t: 'click',
            pos_id: '1662_1667_',
            source: 'pc'
        }
    },
    aiTTSAsr: {
        logger: aiTTSAsrLogger,
        commonParams: {
            from: 'script',
            ev_l_t: 'click',
            pos_id: '1662__',
            source: 'pc'
        }
    },
    aigcImg: {
        logger: aigcImgLogger,
        commonParams: {
            from: 'huibo',
            ev_l_t: 'click',
            pos_id: '1662__'
        }
    },
    homeSource: {
        logger: homeSourceLogger,
        commonParams: {
            from: 'huibo',
            ev_l_t: 'show',
            pos_id: '1662_2172_'
        }
    },
    mobileRegisterClk: {
        logger: mobileRegisterClkLogger,
        commonParams: {
            from: 'huibo',
            ev_l_t: 'show',
            pos_id: '1662_2172_'
        }
    },
    efficiency: {
        logger: efficiencyLogger,
        commonParams: {
            from: 'huibo',
            ev_l_t: 'click',
            pos_id: '1662_1663_'
        }
    },
    aigcVideoCreate: {
        logger: aigcVideoCreateLogger,
        commonParams: {
            from: 'huibo',
            ev_l_t: 'click',
            pos_id: '1662_1664_'
        }
    },
    goodsScenes: {
        logger: goodsScenesLogger,
        commonParams: {
            from: 'huibo',
            ev_l_t: 'click',
            pos_id: '1662_1664_'
        }
    },
    aigcVideoDownload: {
        logger: aigcVideoDownloadLogger,
        commonParams: {
            from: 'huibo',
            ev_l_t: 'click',
            pos_id: '1662_1665_'
        }
    },
    aigcVideoLaunch: {
        logger: aigcVideoLaunchLogger,
        commonParams: {
            from: 'huibo',
            ev_l_t: 'click',
            pos_id: '1662__'
        }
    },
    reserveErnieFaq: {
        logger: reserveErnieFaqLogger,
        commonParams: {
            from: 'huibo',
            ev_l_t: 'click',
            pos_id: '1662_1665_'
        }
    },
    headerActionBar: {
        logger: headerAcitonBarLogger,
        commonParams: {
            from: 'huibo',
            ev_l_t: 'click',
            pos_id: '1662_1663_'
        }
    },
    headerRightBar: {
        logger: headerRightBarLogger,
        commonParams: {
            from: 'huibo',
            ev_l_t: 'click',
            pos_id: '1662_1663_'
        }
    },
    adjust: {
        logger: adjustLogger,
        commonParams: {
            from: 'huibo',
            ev_l_t: 'click',
            pos_id: '1662_1666_'
        }
    },
    templateCreate: {
        logger: templateCreateLogger,
        commonParams: {
            from: 'huibo',
            ev_l_t: 'click',
            pos_id: '1662__'
        }
    },
    editorMenu: {
        logger: editorMenuFloatLogger,
        commonParams: {
            from: 'huibo',
            ev_l_t: 'click',
            pos_id: '1662__'
        }
    },
    editorMenuRight: {
        logger: editorMenuRightLogger,
        commonParams: {
            from: 'huibo',
            ev_l_t: 'click',
            pos_id: '1662__'
        }
    },
    editorHotKey: {
        logger: editorHotKeyLogger,
        commonParams: {
            from: 'huibo',
            ev_l_t: 'click',
            pos_id: '1662__'
        }
    },
    aigcQuestionsAnswers: {
        logger: aigcQuestionsAnswersLogger,
        commonParams: {
            from: 'huibo',
            ev_l_t: 'click',
            pos_id: '1662__'
        }
    },
    productTabLibrary: {
        logger: productTabLibraryLogger,
        commonParams: {
            from: 'huibo',
            ev_l_t: 'click',
            pos_id: '1662__'
        }
    },
    productEditLibrary: {
        logger: productEditLibraryLogger,
        commonParams: {
            from: 'huibo',
            ev_l_t: 'click',
            pos_id: '1662__'
        }
    },
    productQALibrary: {
        logger: productQALibraryLogger,
        commonParams: {
            from: 'huibo',
            ev_l_t: 'click',
            pos_id: '1662__'
        }
    },
    sayas: {
        logger: sayasLogger,
        commonParams: {
            from: 'huibo',
            ev_l_t: 'click',
            pos_id: '1662__'
        }
    },
    entryGuidePage: {
        logger: entryGuidePageLogger,
        commonParams: {
            from: 'huibo',
            ev_l_t: 'click',
            pos_id: '1662__'
        }
    },
    scripList: {
        logger: scripListLogger,
        commonParams: {
            from: 'huibo',
            ev_l_t: 'click',
            pos_id: '1662__'
        }
    },
    infoBanner: {
        logger: infoBannerLogger,
        commonParams: {
            from: 'huibo',
            ev_l_t: 'click',
            pos_id: '1662__'
        }
    },
    riskDiagnosis: {
        logger: riskDiagnosisLogger,
        commonParams: {
            from: 'huibo',
            ev_l_t: 'click',
            pos_id: '1662__'
        }
    },
    learnCenter: {
        logger: learnCenterLogger,
        commonParams: {
            from: 'huibo',
            ev_l_t: 'click',
            pos_id: '1662__'
        }
    },
    layerManager: {
        logger: layerManagerLogger,
        commonParams: {
            from: 'huibo',
            ev_l_t: 'click',
            pos_id: '1662__'
        }
    },
    createCharacter: {
        logger: createCharacterLogger,
        commonParams: {
            from: 'huibo',
            ev_l_t: 'click',
            pos_id: '1662__',
            source: 'pc'
        }
    },
    createPpt: {
        logger: createPptLogger,
        commonParams: {
            from: 'huibo',
            ev_l_t: 'click',
            pos_id: '1662__',
            source: 'pc'
        }
    },
    pptOperate: {
        logger: pptOperateLogger,
        commonParams: {
            from: 'huibo',
            ev_l_t: 'click',
            pos_id: '1662__',
            source: 'pc'
        }
    },
    pptSwitch: {
        logger: pptSwitchLogger,
        commonParams: {
            from: 'huibo',
            ev_l_t: 'click',
            pos_id: '1662__',
            source: 'pc'
        }
    },
    pptClip: {
        logger: pptClipLogger,
        commonParams: {
            from: 'huibo',
            ev_l_t: 'click',
            pos_id: '1662__',
            source: 'pc'
        }
    },
    pasterUsed: {
        logger: pasterUsedLogger,
        commonParams: {
            from: 'huibo',
            ev_l_t: 'click',
            pos_id: '1662__',
            source: 'pc'
        }
    },
    rookieGuide: {
        logger: rookieGuideLogger,
        commonParams: {
            from: 'huibo',
            ev_l_t: 'click',
            pos_id: '1662__',
            source: 'pc'
        }
    },
    swanClone: {
        logger: swanCloneLogger,
        commonParams: {
            from: 'huibo',
            ev_l_t: 'click',
            pos_id: '1662__',
            source: 'pc'
        }
    }
};

function log(type, params = {}, action = 'click') {
    try {
        const {value, extParam = {}, source = 'pc'} = params;
        const {logger, commonParams} = logMap[type];

        logger.send({
            ...commonParams,
            type: action,
            value,
            source,
            ext: extParam
        });

        // console.log('log =====>', {
        //     value,
        //     ext: extParam
        // });
    }
    catch (e) {
        // safe log
    }
}


// agic生成剧本 相关埋点 end

// 背景素材相关埋点 start
export const clickBgTabLog = (tab, params) => {
    const valMap = {
        bg_img: 'bg_pic',
        bg_video: 'bg_video',
        solid: 'bg_pure',
        gradient: 'bg_change'
    };

    log('bg', {
        value: valMap[tab] || ''
    });
};

export const clickBgItemLog = (tab, params) => {
    const valMap = {
        bg_img: 'bg_pic_choose',
        bg_video: 'bg_video_choose',
        solid: 'bg_pure_choose',
        gradient: 'bg_change_choose',
        ai_bg_img: 'bg_aiimg_choose'
    };

    log('bg', {
        value: valMap[tab] || ''
    });
};

export const clickBgUploadLog = (tab, params) => {
    const valMap = {
        bg_img: 'bg_pic_upload',
        bg_video: 'bg_video_upload',
        solid: 'bg_pure_choose',
        gradient: 'bg_change_choose'
    };

    log('bg', {
        value: valMap[tab] || ''
    });
};

export const clickBgClipLog = (oriDur, dur) => {
    log('bg', {
        value: 'bg_video_clip',
        extParam: {
            video_time: Number(oriDur),
            video_clip_time: Number(dur)
        }
    });
};

export const clickBgCropLog = bgTab => {
    const valMap = {
        bg_img: 'bg_pic_crop',
        bg_video: 'bg_video_crop'
    };

    log('bg', {
        value: valMap[bgTab] || ''
    });
};
// 背景素材相关埋点 end

// 问答相关埋点 start
// 手动添加
export const addFaqLog = params => {
    log('faq', {
        value: 'qa_manual',
        extParam: params
    });
};

export const addAIFaqLog = params => {
    log('faq', {
        value: 'qa_ai',
        extParam: params
    });
};

export const addExcelLog = params => {
    log('faq', {
        value: 'qa_excel',
        extParam: params
    });
};
// 问答相关埋点 end

// AI生成预约内容相关埋点 start
export const aiNewReserveAllLog = () => {
    log('reserveAI', {
        value: 'once'
    });
};

export const aiNewReserveTitleLog = () => {
    log('reserveAI', {
        value: 'title'
    });
};

export const aiNewReserveDescLog = () => {
    log('reserveAI', {
        value: 'brief'
    });
};
// AI生成预约内容相关埋点 end

// AI辅写相关埋点 start
export const aiTTSTextCancelLog = () => {
    log('aiTTSText', {
        value: 'cancel'
    });
};

export const aiTTSTextConfirmLog = (options = []) => {
    const optMap = {
        expand: 'extend',
        reduce: 'simplify',
        improve: 'polish',
        adjust_tone: 'modify'
    };

    let exts = {
        in_type: optMap[options[0]]
    };

    if (options[0] === 'adjust_tone') {
        exts.style = options[1];
    }

    log('aiTTSText', {
        value: 'confirm',
        extParam: exts
    });
};

export const aiTTSTextCloseLog = () => {
    log('aiTTSText', {
        value: 'exit'
    });
};

export const aiTTSTextRedoLog = () => {
    log('aiTTSText', {
        value: 'redo'
    });
};

// ASR功能打点
export const aiTTSAsrLog = (value, extParam) => {
    log('aiTTSAsr', {
        value,
        extParam
    });
};

export const aiTTSTextClickOptionLog = (options = []) => {
    const optMap = {
        expand: 'extend',
        reduce: 'simplify',
        improve: 'polish',
        adjust_tone: 'modify'
    };

    let exts = {};

    if (options[0] === 'adjust_tone') {
        exts.style = options[1];
    }

    log('aiTTSText', {
        value: optMap[options[0]],
        extParam: exts
    });
};
// AI辅写相关埋点 end

// AI生成背景图 start
export const aiimgClickEntryLog = () => {
    log('aigcImg', {
        value: 'aigc_image_entrance'
    });
};

export const aiimgClickScriptEntryLog = () => {
    log('aigcImg', {
        value: 'aigc_image_script_entrance'
    });
};

export const aiimgClickScriptTabEntryLog = () => {
    log('aigcImg', {
        value: 'aigc_image_script_AIentrance'
    });
};

export const aiimgClickFilterLog = () => {
    log('aigcImg', {
        value: 'aigc_image_filter'
    });
};

export const aiimgFilterGoodsLog = goods => {
    log('aigcImg', {
        value: 'aigc_image_select_success',
        extParam: {
            ext_goods_ID: goods.goods_id,
            ext_goods_name: goods.goods_name
        }
    });
};

export const aiimgClickImportLog = (styleItem, url) => {
    log('aigcImg', {
        value: 'aigc_image_import',
        extParam: {
            ext_imageinfo: url,
            // ext_imageinfo: 'aigc_image_import_URL',
            ext_import_style: JSON.stringify(styleItem)
        }
    });
};

export const aiimgClickRetryLog = () => {
    log('aigcImg', {
        value: 'aigc_image_regenerate'
    });
};

export const aiimgClickSelectLog = () => {
    log('aigcImg', {
        value: 'aigc_image_select'
    });
};

export const aiimgClickUploadLog = () => {
    log('aigcImg', {
        value: 'aigc_image_upload',
        extParam: {
            ext_imageinfo: 'aigc_image_import_URL'
        }
    });
};

export const aiimgClickMoodRetryLog = mood => {
    log('aigcImg', {
        value: 'aigc_image_chose_regenerate',
        extParam: {
            ext_image_chose_regenerate: mood
        }
    });
};
// AI生成背景图 end

// 首页来源 start
export const homeSourceLog = () => {
    const hash = location.hash;
    const {anchor, qd} = parseUrl(location.search) || {};
    const valMap = {
        '#/': 'all',
        '#/home_': 'home',
        '#/home_functional': 'home_advantage', // 技术优势
        '#/home_home': 'home_function', // 王牌功能
        '#/home_liveflow': 'home_procedure', // 开播流程
        '#/home_cases': 'home_showcase', // 精彩案例
        '#/mobile_': 'mobile',
        '#/mobile_functional': 'mobile_advantage', // 技术优势
        '#/mobile_home': 'mobile_function', // 王牌功能
        '#/mobile_liveflow': 'mobile_procedure', // 开播流程
        '#/mobile_cases': 'mobile_showcase' // 精彩案例
    };

    log('homeSource', {
        value: valMap[`${hash}_${anchor || ''}`] || 'all',
        extParam: {qd}
    });
};

export const webVisitLog = (value) => {
    /**
     * value = 'visit'//访问
     * value = 'register'登录慧播星
     * value = authorority 有权限访问
     */
    log('homeSource', {
        value
    });
};
// 首页来源 end

// 操作效率 start
export const efficiencyLog = (val, type, params = {}) => {
    try {
        if (!window.huibo_b_efficiency) {
            window.huibo_b_efficiency = {};
        }

        if (type === 'start') {
            window.huibo_b_efficiency[val] = {
                start_time: Date.now(),
                ...params
            };
        }

        if (type === 'end') {
            // 无效结束
            if (!window.huibo_b_efficiency[val] && !window.huibo_b_efficiency[val].start_time) {
                return;
            }
            window.huibo_b_efficiency[val] = {
                end_time: Date.now(),
                ...window.huibo_b_efficiency[val],
                ...params
            };

            const {start_time: start, end_time: end} = window.huibo_b_efficiency[val] || {};

            // 操作时间超过10min或小于500ms则不记录，避免数据偏差
            if ((end - start > 10 * 60 * 1000) || (end - start < 500)) {
                return;
            }

            log('efficiency', {
                value: val,
                extParam: {
                    ...window.huibo_b_efficiency[val],
                    duration: end - start
                }
            });

            // 记录一次埋点后复位
            window.huibo_b_efficiency[val] = {};
        }
    }
    catch (e) {
        console.error(e);
    }
};
// 操作效率 end

// AI生成视频 start
export const aiVideoCreateLog = ext => {
    log('aigcVideoCreate', {
        value: 'click_Generatevideobutton',
        extParam: ext
    });
};

// 移动端即刻入驻点击
export const mobileRegisterClkLog = (type, ext) => {
    const value = 'mobile_entrance_' + type;
    log('mobileRegisterClk', {
        value: value,
        extParam: ext
    });
};

export const aiVideoDownloadLog = ext => {
    log('aigcVideoDownload', {
        value: 'click_downloadvideobutton',
        extParam: ext
    });
};

export const aiVideoLaunchLog = async (id, content, recordVideo) => {
    const pageList = JSON.parse(content);
    const url = recordVideo.video_url;
    const {durationInSecond: dur} = await getVideoMetaInfo(`${url}?x-bce-process=video/info`);

    log('aigcVideoLaunch', {
        value: 'click_delivervideo',
        extParam: {
            spuid: pageList.map(item => item.goods.id).join(','),
            scriptID: id,
            click_time: formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss'),
            videourl: url,
            videotype: pageList.some(ele => ele.bg_video?.url) ? 'hbx-2' : 'hbx-1',
            video_time: String(dur),
            ucid: ' ',
            spu_name: pageList.map(item => item.goods.name).join(','),
            spu_type: ' '
        }
    });
};
// AI生成视频 end

// 商品分镜操作 start
export const goodsScenesBtnLog = (btn, ext) => {
    const valMap = {
        good_change_btn: 'good_change_btn',
        good_change_rightClick: 'good_change_rightClick',
        good_copy_btn: 'good_copy_btn',
        good_delete_btn: 'good_delete_btn',
        good_delete_rightClick: 'good_delete_rightClick',
        storyboard_copy_btn: 'storyboard_copy_btn',
        storyboard_copy_rightClick: 'storyboard_copy_rightClick',
        storyboard_delete_btn: 'storyboard_delete_btn',
        storyboard_delete_rightClick: 'storyboard_delete_rightClick'
    };

    log('goodsScenes', {
        value: valMap[btn],
        extParam: {
            ...ext
        }
    });
};

// 商品分镜操作 end

// 预约开播 授权文心接管问答 start
export const reserveErnieFaqCheckboxClick = params => {
    log('reserveErnieFaq', {
        value: 'click_open',
        extParam: params
    });
};

export const reserveErnieFaqPopoverClick = params => {
    log('reserveErnieFaq', {
        value: 'click_button_open',
        extParam: params
    });
};
// 预约开播 授权文心接管问答 end

// 顶部素材按钮 start
export const clickHeaderImageEntryLog = params => {
    log('headerActionBar', {
        value: 'click',
        extParam: params
    });
};

export const clickHeaderImageChooseLog = category => {
    const categoryMap = {
        init_latest: 'recent',
        init_my: 'custom'
    };
    log('headerActionBar', {
        value: 'choose',
        extParam: {
            admin_type: categoryMap[category] || '',
            tag_type: category
        }
    });
};

export const clickHeaderCharacterEntryLog = params => {
    log('headerActionBar', {
        value: 'digital_click',
        extParam: params
    });
};

export const clickHeaderCharacterChooseLog = params => {
    log('headerActionBar', {
        value: 'digital_choose',
        extParam: params
    });
};

export const clickHeaderCharacterUploadLog = params => {
    log('headerActionBar', {
        value: 'digital_upload',
        extParam: params
    });
};

export const clickHeaderImageSearchLog = query => {
    log('headerActionBar', {
        value: 'search',
        extParam: {
            search_content: query
        }
    });
};

export const clickHeaderImageUploadLog = params => {
    log('headerActionBar', {
        value: 'upload',
        extParam: params
    });
};

export const clickHeaderTextEntryLog = params => {
    log('headerActionBar', {
        value: 'word_click',
        extParam: params
    });
};

export const clickHeaderTextChooseLog = type => {
    const valMap = {
        添加标题: 'title',
        添加副标题: 'subtitle',
        添加正文段落: 'text'
    };

    log('headerActionBar', {
        value: 'word_choose',
        extParam: {
            word_type: valMap[type] || ''
        }
    });
};
// 顶部素材按钮 end

// 顶部右侧操作按钮 start
export const clickHeaderRightReserveLog = () => {
    log('headerRightBar', {
        value: 'appointment'
    });
};

export const clickHeaderRightTitleEditLog = () => {
    log('headerRightBar', {
        value: 'edit_name'
    });
};

export const clickHeaderRightPreviewLog = () => {
    log('headerRightBar', {
        value: 'preview'
    });
};

export const clickHeaderRightHistoryBackLog = () => {
    log('headerRightBar', {
        value: 'redo'
    });
};

export const clickHeaderRightHistoryGoLog = () => {
    log('headerRightBar', {
        value: 'repeal'
    });
};

export const clickHeaderRightTaskLog = () => {
    log('headerRightBar', {
        value: 'task_center'
    });
};
// 顶部右侧操作按钮 end

// 布局调整按钮 start
const typeMap = {
    image: 'picture',
    character: 'digital_human',
    txt: 'word',
    music: 'music'
};
export const clickAdjustAlignLog = (type, align) => {
    const alignMap = {
        alignTop: 'top',
        alignLeft: 'left',
        alignCenter: 'center',
        alignRight: 'right',
        alignMiddle: 'middle',
        alignBottom: 'bottom'
    };

    log('adjust', {
        value: 'alignment',
        extParam: {
            type: typeMap[type] || '',
            alignment_type: alignMap[align] || ''
        }
    });
};

export const clickAdjustLayerLog = (type, layer) => {
    const layerMap = {
        layerUp: 'forward',
        layerTop: 'foremost',
        layerDown: 'backward',
        layerBottom: 'last'
    };

    log('adjust', {
        value: 'hierarchy',
        extParam: {
            type: typeMap[type] || '',
            hierarchy_type: layerMap[layer] || ''
        }
    });
};

export const clickAdjustXYLog = type => {
    log('adjust', {
        value: 'xy',
        extParam: {
            type: typeMap[type] || ''
        }
    });
};

export const clickAdjustApplyAllLog = type => {
    log('adjust', {
        value: 'apply_all',
        extParam: {
            type: typeMap[type] || ''
        }
    });
};

// 选择数字人
export const clickChooseNumberManLog = ({
    figure_id, name
}) => {
    log('templateCreate', {
        value: 'AI-people',
        extParam: {
            id: figure_id,
            name: name
        }
    });
};
// 数字人换一换
export const clickNumberManChangeLog = () => {
    log('templateCreate', {
        value: 'AI-people-change'
    });
};
const AI_TABS_2_VALUE = {
    ai: 'AI-template',
    pub: 'public-template',
    self: 'my-template'
};
// 模板Tab点击
export const clickTemplateTabsLog = (type) => {
    log('templateCreate', {
        value: AI_TABS_2_VALUE[type]
    });
};
// AI模板换一换
export const clickAITemplateChangeLog = () => {
    log('templateCreate', {
        value: 'AI-template-change'
    });
};
// 公共模板类型Tab点击
export const clickPublicTemplateTypeLog = (type) => {
    log('templateCreate', {
        value: 'public-template-types',
        extParam: {
            type: type
        }
    });
};
// 公共模板选择
export const clickPublicTemplateChooseLog = (item) => {
    log('templateCreate', {
        value: 'public-template-message',
        extParam: {
            id: item.id,
            name: item.show_name
        }
    });
};
// AI模板选择
export const clickAITemplateChooseLog = (item) => {
    log('templateCreate', {
        value: 'AI-template-message',
        extParam: {
            id: item.id,
            name: item.show_name
        }
    });
};

// 顶部模板类型点击
export const clickTopTemplateTypeLog = (category) => {
    log('templateCreate', {
        value: 'top-tab-template-types',
        extParam: {
            category
        }
    });
};
// 顶部模板点击
export const clickTopTemplateClickLog = () => {
    log('templateCreate', {
        value: 'top-tab-template'
    });
};
// 顶部模板选择
export const clickTopTemplateChooseLog = ({
    id, show_name
}) => {
    log('templateCreate', {
        value: 'top-tab-template-message',
        extParam: {
            id,
            name: show_name
        }
    });
};

// 顶部贴图点击
export const clickTopMapsClickLog = () => {
    log('templateCreate', {
        value: 'top-tab-maps'
    });
};
// 顶部贴图类型
export const clickTopMapsTypeLog = (category) => {
    log('templateCreate', {
        value: 'top-tab-maps-types',
        extParam: {
            category
        }
    });
};
// 顶部贴图选择
export const clickTopMapsChooseLog = ({
    id, name
}) => {
    log('templateCreate', {
        value: 'top-tab-maps-message',
        extParam: {
            id,
            name
        }
    });
};

// 添加为我的模板
export const clickAddMyTemplateLog = () => {
    log('templateCreate', {
        value: 'add-my-template'
    });
};
// 添加商品
export const clickAddGoodsLog = () => {
    log('templateCreate', {
        value: 'add-goods'
    });
};
// 布局调整按钮 end

// 编辑器悬浮菜单,创建副本
export const clickFLoatBackup = () => {
    log('editorMenu', {
        value: 'floatwindow_type',
        extParam: {
            floatwindow_type: 'backup'
        }
    });
};
// 编辑器悬浮菜单,点击删除
export const clickFLoatDel = () => {
    log('editorMenu', {
        value: 'floatwindow_type',
        extParam: {
            floatwindow_type: 'delete'
        }
    });
};
// 编辑器悬浮菜单,点击更多
export const clickFLoatMore = () => {
    log('editorMenu', {
        value: 'floatwindow_type',
        extParam: {
            floatwindow_type: 'more'
        }
    });
};
// 编辑器悬浮菜单,点击复制
export const clickFLoatCopy = () => {
    log('editorMenu', {
        value: 'floatwindow_type',
        extParam: {
            floatwindow_type: 'copy'
        }
    });
};
// 编辑器悬浮菜单,点击粘贴
export const clickFLoatPaste = () => {
    log('editorMenu', {
        value: 'floatwindow_type',
        extParam: {
            floatwindow_type: 'paste'
        }
    });
};
// 编辑器悬浮菜单,点击剪切
export const clickFLoatCut = () => {
    log('editorMenu', {
        value: 'floatwindow_type',
        extParam: {
            floatwindow_type: 'cut'
        }
    });
};
// 编辑器悬浮菜单,点击撤销
export const clickFLoatCancel = () => {
    log('editorMenu', {
        value: 'floatwindow_type',
        extParam: {
            floatwindow_type: 'cancel'
        }
    });
};
// 编辑器悬浮菜单,点击恢复
export const clickFLoatRecover = () => {
    log('editorMenu', {
        value: 'floatwindow_type',
        extParam: {
            floatwindow_type: 'recover'
        }
    });
};
// 编辑器悬浮菜单,点击复制文字样式
export const clickFLoatCopyformat = () => {
    log('editorMenu', {
        value: 'floatwindow_type',
        extParam: {
            floatwindow_type: 'copyformat'
        }
    });
};
// 编辑器悬浮菜单,点击粘贴文字样式
export const clickFLoatPasteformat = () => {
    log('editorMenu', {
        value: 'floatwindow_type',
        extParam: {
            floatwindow_type: 'pasteformat'
        }
    });
};
// 编辑器悬浮菜单,点击成组
export const clickFLoatGroup = () => {
    log('editorMenu', {
        value: 'floatwindow_type',
        extParam: {
            floatwindow_type: 'group'
        }
    });
};
// 编辑器悬浮菜单,点击解组
export const clickFLoatUngroup = () => {
    log('editorMenu', {
        value: 'floatwindow_type',
        extParam: {
            floatwindow_type: 'ungroup'
        }
    });
};
// 编辑器悬浮菜单,点击查看快捷键
export const clickFLoatShortcut = () => {
    log('editorMenu', {
        value: 'floatwindow_type',
        extParam: {
            floatwindow_type: 'shortcut'
        }
    });
};

// 编辑器右键菜单,点击复制
export const clickRightCopy = () => {
    log('editorMenuRight', {
        value: 'right_click',
        extParam: {
            right_click: 'copy'
        }
    });
};
// 编辑器右键菜单,点击粘贴
export const clickRightPaste = () => {
    log('editorMenuRight', {
        value: 'right_click',
        extParam: {
            right_click: 'paste'
        }
    });
};
// 编辑器右键菜单,点击剪切
export const clickRightCut = () => {
    log('editorMenuRight', {
        value: 'right_click',
        extParam: {
            right_click: 'cut'
        }
    });
};
// 编辑器右键菜单,点击撤销
export const clickRightCancel = () => {
    log('editorMenuRight', {
        value: 'right_click',
        extParam: {
            right_click: 'cancel'
        }
    });
};
// 编辑器右键菜单,点击恢复
export const clickRightRecover = () => {
    log('editorMenuRight', {
        value: 'right_click',
        extParam: {
            right_click: 'recover'
        }
    });
};
// 编辑器右键菜单,点击复制文字样式
export const clickRightCopyformat = () => {
    log('editorMenuRight', {
        value: 'right_click',
        extParam: {
            right_click: 'copyformat'
        }
    });
};
// 编辑器右键菜单,点击粘贴文字样式
export const clickRightPasteformat = () => {
    log('editorMenuRight', {
        value: 'right_click',
        extParam: {
            right_click: 'pasteformat'
        }
    });
};
// 编辑器右键菜单,点击成组
export const clickRightGroup = () => {
    log('editorMenuRight', {
        value: 'right_click',
        extParam: {
            right_click: 'group'
        }
    });
};
// 编辑器右键菜单,点击解组
export const clickRightUngroup = () => {
    log('editorMenuRight', {
        value: 'right_click',
        extParam: {
            right_click: 'ungroup'
        }
    });
};
// 编辑器右键菜单,点击查看快捷键
export const clickRightShortcut = () => {
    log('editorMenuRight', {
        value: 'right_click',
        extParam: {
            right_click: 'shortcut'
        }
    });
};

// 编辑器快捷键,复制
export const hotKeyLogCopy = () => {
    log('editorHotKey', {
        value: 'shortcut',
        extParam: {
            shortcut_type: 'copy'
        }
    });
};
// 编辑器快捷键,粘贴
export const hotKeyLogPaste = () => {
    log('editorHotKey', {
        value: 'shortcut',
        extParam: {
            shortcut_type: 'paste'
        }
    });
};
// 编辑器快捷键,剪切
export const hotKeyLogCut = () => {
    log('editorHotKey', {
        value: 'shortcut',
        extParam: {
            shortcut_type: 'cut'
        }
    });
};
// 编辑器快捷键,撤销
export const hotKeyLogCancel = () => {
    log('editorHotKey', {
        value: 'shortcut',
        extParam: {
            shortcut_type: 'cancel'
        }
    });
};
// 编辑器快捷键,恢复
export const hotKeyLogRecover = () => {
    log('editorHotKey', {
        value: 'shortcut',
        extParam: {
            shortcut_type: 'recover'
        }
    });
};
// 编辑器快捷键,复制文字样式
export const hotKeyLogCopyformat = () => {
    log('editorHotKey', {
        value: 'shortcut',
        extParam: {
            shortcut_type: 'copyformat'
        }
    });
};
// 编辑器快捷键,粘贴文字样式
export const hotKeyLogPasteformat = () => {
    log('editorHotKey', {
        value: 'shortcut',
        extParam: {
            shortcut_type: 'pasteformat'
        }
    });
};
// 编辑器快捷键,成组
export const hotKeyLogGroup = () => {
    log('editorHotKey', {
        value: 'shortcut',
        extParam: {
            shortcut_type: 'group'
        }
    });
};
// 编辑器快捷键,解组
export const hotKeyLogUngroup = () => {
    log('editorHotKey', {
        value: 'shortcut',
        extParam: {
            shortcut_type: 'ungroup'
        }
    });
};

// 一言问答去优化打点
export const aigcQuestionsAnswersLog = (value, action, ext) => {
    log('aigcQuestionsAnswers', {
        value,
        extParam: ext || {}
    }, action);
};

// 商品问答库数据埋点
export const productLibraryLog = (page, value) => {
    const productLibraryMap = {
        tab: 'productTabLibrary',
        script_edit: 'productEditLibrary',
        Q_A: 'productQALibrary'
    };
    log(productLibraryMap[page], {
        value
    });
};
// 选择读音打点
export const sayasLog = (value, ext) => {
    log('sayas', {
        value,
        extParam: ext || {}
    });
};
// 入驻引导页
export const entryGuidePageLog = (value) => {
    log('entryGuidePage', {
        value
    });
};

// 剧本页
export const scripListLog = (value, ext) => {
    log('scripList', {
        value,
        extParam: ext || {}
    });
};

// 通知与banner点位
export const infoBannerLog = (value, ext) => {
    log('infoBanner', {
        value,
        extParam: ext || {}
    });
};

// 风控与诊断
export const riskDiagnosisLog = (value, ext) => {
    log('riskDiagnosis', {
        value,
        extParam: ext || {}
    });
};

// 学习中心 点位
export const learnCenterLog = (value, ext) => {
    log('learnCenter', {
        value,
        extParam: ext || {}
    });
};
// 图层管理器打点
export const layerManagerLog = (ext) => {
    log('layerManager', {
        value: 'layer_click'
    });
};
export const createCharacterLog = (value, ext) => {
    log('createCharacter', {
        value,
        extParam: ext || {}
    });
};

export const createPptLog = () => {
    log('createPpt', {
        value: 'ppt_click',
        extParam: {
            ppt_click: true
        }
    });
};

export const pptOperateLog = (value, ext) => {
    log('pptOperate', {
        value,
        extParam: ext || {}
    });
};

export const pptSwitchLog = (type) => {
    log('pptSwitch', {
        value: 'ppt_relation_click',
        extParam: {
            ppt_relation_type: type
        }
    });
};

export const pptClipLog = () => {
    log('pptClip', {
        value: 'ppt_crop_click',
        extParam: {
            ppt_crop_click: true
        }
    });
};

export const pasterUsedLog = (ext) => {
    log('pasterUsed', {
        value: 'paster_used_click',
        extParam: ext || {}
    });
};

export const rookieGuideLog = (value, step_number, type = 'click') => {
    const hash = store.guideType.hash;
    const key = store.guideType.key;
    let source = '';
    let step_own = '';
    if (hash && key) {
        switch (hash) {
            case '#/editor':
                source = 'inner';
                step_own = key === 'create' ? 'inner1' : key === 'fit-1' ? 'inner2' : 'inner3';
                break;
            case '#/script':
                source = 'outter';
                step_own = key === 'create' ? 'outter1' : 'outter2';
                break;
            default:
        }
    }
    log('rookieGuide', {
        value,
        source,
        extParam: {
            step_number,
            step_own
        }
    }, type);
};

export const swanCloneLog = (ext) => {
    log('swanClone', {
        value: 'swan_clone_click',
        extParam: ext || {}
    });
};
